import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const painPoints = ['Querés cocinar algo rico pero el miedo a la glucosa te frena antes de empezar.', 'Probás recetas sin gluten que terminan secas, caras o imposibles de repetir.', 'Gastás en ingredientes especiales y el resultado igual no sale bien.', 'Mirás recetas en Instagram y sentís que jamás podrías lograr algo así.', 'Terminás cada semana prometiéndote que la próxima vez sí va a funcionar.'];
export function PainBlock() {
  return <section className="py-20 sm:py-24 px-4 bg-brand-base border-t border-brand-gold/15 relative overflow-hidden" data-id="element-207">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-208"></div>

      <div className="max-w-2xl mx-auto relative z-10 mt-[-10px] mb-[-10px]" data-id="element-209">
        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display font-extrabold text-[#FAF6F0] text-[28px] sm:text-[44px] text-center mx-auto max-w-[22ch] tracking-tight leading-[1.15] mb-6" data-id="element-210">
          ¿Cuántos domingos más vas a terminar así?
        </motion.h2>

        {/* Explanatory paragraph */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.08
      }} className="max-w-[44ch] mx-auto text-center mb-10 space-y-4" data-id="element-211">
          <p className="text-brand-cream/75 text-[14px] sm:text-base leading-relaxed mt-[-10px] mb-[-10px]" data-id="element-212">
            Pasás horas buscando recetas en internet, gastando ingredientes y
            llegando al final de la semana con la sensación de que nada funciona
            como debería.
          </p>
        </motion.div>

        {/* Highlight line */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="font-display text-[22px] sm:text-3xl font-bold text-brand-gold text-center leading-[1.2] sm:mb-14 mt-[10px] mb-[10px]" data-id="element-213">
          No es falta de ganas.
          <br data-id="element-214" />
          Es falta de un sistema.
        </motion.p>

        {/* Cards */}
        <div className="flex flex-col gap-3 sm:gap-4" data-id="element-215">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="rounded-2xl p-5 sm:p-6 flex items-start gap-4 pt-[20px] pb-[20px]" style={{
          background: '#1A0606',
          border: '1px solid #7A1010'
        }} data-id="element-216">
              <span className="shrink-0 flex items-center justify-center rounded-full" style={{
            width: 36,
            height: 36,
            background: 'rgba(204, 34, 0, 0.12)',
            border: '1px solid rgba(204, 34, 0, 0.45)',
            color: '#FF4D33'
          }} aria-hidden data-id="element-217">
                <X size={18} strokeWidth={3} data-id="element-218" />
              </span>
              <p className="text-brand-cream text-[14px] sm:text-base font-medium leading-relaxed flex-1 pt-1" data-id="element-219">
                {point}
              </p>
            </motion.div>)}
        </div>

        {/* Closing line */}
        <motion.p initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display italic text-brand-cream text-[18px] sm:text-2xl text-center mt-14 sm:mt-16 leading-snug max-w-[28ch] mx-auto" data-id="element-220">
          ¿Y si esta fuera la última vez que pasó eso?
        </motion.p>
      </div>
    </section>;
}